import React from 'react';
import { FadeIn } from './FadeIn';
export function ScienceSection() {
  const coverUrl = 'https://cdn.magicpatterns.com/uploads/gKUFq959Y73zKV8vJ7SPih/ChatGPT_Image_7_jun_2026,_10_42_20_a.m..png';
  const scienceFacts = [{
    emoji: '🔬',
    text: 'MBSR equivale a antidepresivo ISRS para ansiedad (Hoge et al., JAMA Psychiatry, 2022)'
  }, {
    emoji: '🏃',
    text: 'El ejercicio reduce ansiedad con efecto g = -0.42 (Singh et al., BJSM, 2023)'
  }, {
    emoji: '🌬️',
    text: 'El suspiro fisiológico supera a la meditación con 5 min/día (Balban et al., Cell Reports, 2023)'
  }];
  return <section className="py-20 bg-white" data-id="element-161">
      <div className="max-w-6xl mx-auto px-6" data-id="element-162">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-163">
          {/* Left Side - Image */}
          <div className="w-full md:w-1/2" data-id="element-164">
            <FadeIn direction="right" data-id="element-165">
              <div className="relative w-full max-w-md mx-auto aspect-[3/5]" data-id="element-166">
                <div className="absolute inset-0 bg-brand-forest opacity-10 rounded-3xl transform -translate-x-4 translate-y-4" data-id="element-167"></div>
                <img src={coverUrl} alt="Mujer meditando en la naturaleza con representación de claridad mental" className="relative z-10 w-full h-full object-cover rounded-2xl shadow-xl" data-id="element-168" />
              </div>
            </FadeIn>
          </div>

          {/* Right Side - Content */}
          <div className="w-full md:w-1/2" data-id="element-169">
            <FadeIn data-id="element-170">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest mb-6" data-id="element-171">
                No es autoayuda.
                <br data-id="element-172" />
                Es ciencia aplicada.
              </h2>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-173">
              <div className="text-brand-charcoal space-y-4 mb-8 leading-relaxed" data-id="element-174">
                <p data-id="element-175">
                  Cada módulo de esta guía está respaldado por estudios
                  publicados en revistas científicas internacionales.
                </p>
                <p data-id="element-176">
                  El meta-análisis más grande de la historia del ejercicio y
                  salud mental (Singh et al., British Journal of Sports
                  Medicine, 2023 — 128.119 participantes) confirma que el
                  movimiento es tan efectivo como los antidepresivos para
                  ansiedad y depresión leve.
                </p>
                <p data-id="element-177">
                  El estudio de Stanford (Balban et al., Cell Reports Medicine,
                  2023) demostró que 5 minutos de respiración correcta supera a
                  la meditación para reducir ansiedad de forma inmediata.
                </p>
                <p className="font-semibold text-brand-forest" data-id="element-178">
                  Todo esto — y más — está en tus manos en formato práctico y
                  aplicable desde hoy.
                </p>
              </div>
            </FadeIn>

            <div className="space-y-4" data-id="element-179">
              {scienceFacts.map((fact, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-180">
                  <div className="bg-brand-sage bg-opacity-10 border border-brand-sage border-opacity-20 p-4 rounded-xl flex items-start gap-3 hover:bg-opacity-20 transition-colors duration-300" data-id="element-181">
                    <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-182">
                      {fact.emoji}
                    </span>
                    <p className="text-sm font-medium text-brand-forest leading-snug" data-id="element-183">
                      {fact.text}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}